import { render, staticRenderFns } from "./Agent_information.vue?vue&type=template&id=9336e970&"
import script from "./Agent_information.vue?vue&type=script&lang=js&"
export * from "./Agent_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports